const betaURL = require("app/util/config/beta-url");
const CardWithLoader = require("../Dashboard/card-with-loader");
const Summary = require("../Dashboard/summary");
const DetailsLink = require("./details-link");
const CenteredCardContent = require("../Dashboard/centered-card-content");

const Reflux = require("reflux");
const NewDealsStore = require("../../stores/new-deals-store");
const NewDealsActions = require("../../actions/new-deals-actions");

const currencyFormatter = require("app/util/formatter/currency");
const deltaCalculator = require("./util/delta-type");

const AnimatedValue = require("app/shared/components/AnimatedValue/animated-value");

const NewDealsWidget = React.createClass({
  mixins: [Reflux.ListenerMixin],

  getInitialState: function() {
    return NewDealsStore.getInitialState();
  },

  componentDidMount: function() {
    this.listenTo(NewDealsStore, this.setState);
    this.refresh();
  },

  componentDidUpdate: function(prevProps) {
    if (prevProps != this.props) {
      this.refresh();
    }
  },

  refresh: function() {
    NewDealsActions.fetchData(
      this.props.period,
      this.props.comparison,
      this.props.users,
      this.props.funnel
    );
  },

  deltaCountTooltipText: function() {
    const comparisonStart = this.props.comparison.startDate.format("DD MMM, YYYY");
    const comparisonEnd = this.props.comparison.endDate.format("DD MMM, YYYY");
    const comparison = `${comparisonStart} - ${comparisonEnd}`;

    if (this.state.data.countDelta === 0) {
      return `Sem mudanças em relação a ${comparison}`;
    }

    const noun = this.state.data.countDelta > 0 ? "Aumento" : "Diminuição";

    return `${noun} de <b>${Math.abs(this.state.data.countDelta)}</b> novas oportunidades em relação a ${comparison}`;
  },

  deltaTooltipText: function (value, transform) {
    const comparisonStart = this.props.comparison.startDate.format("DD MMM, YYYY");
    const comparisonEnd = this.props.comparison.endDate.format("DD MMM, YYYY");
    const comparison = `${comparisonStart} - ${comparisonEnd}`;

    if (value === 0) {
      return `Sem mudanças em relação a ${comparison}`;
    }

    const noun = value > 0 ? "Aumento" : "Diminuição";

    return `${noun} de <b>${transform(Math.abs(value))}</b> comparado com ${comparison}`;
  },

  tooltipText: function(value, label) {
    const periodStart = this.props.period.startDate.format("DD MMM, YYYY");
    const periodEnd = this.props.period.endDate.format("DD MMM, YYYY");
    const periodText = `${periodStart} - ${periodEnd}`;

    return `<b>${value}</b>${label ? ' ' + label : ''} em ${periodText}`;
  },

  getDetailsUrl: function() {
    let dateFormat = "YYYY-MM-DD";
    let formattedStartDate = this.props.period.startDate.format(dateFormat);
    let formattedEndDate = this.props.period.endDate.format(dateFormat);

    let searchParams = new URLSearchParams();

    searchParams.append("dii", formattedStartDate);
    searchParams.append("dif", formattedEndDate);
    searchParams.append("qpp", 25);

    if (this.props.selectedUser)
      searchParams.append("ur", this.props.selectedUser);
    if (this.props.selectedTeam)
      searchParams.append("team", this.props.selectedTeam);
    if (this.props.funnel)
      searchParams.append("funil", this.props.funnel);

    return `${betaURL()}/deals?${searchParams}`;
  },

  render: function() {
    return (
      <CardWithLoader
        loading={this.state.loading}
        failed={this.state.failed}
        onRetry={this.refresh}
        title={
          <p>Negócios iniciados</p>
        }
        footer={<DetailsLink url={this.getDetailsUrl()} />}
      >
        <CenteredCardContent>
          <Summary
            big
            value={<AnimatedValue value={this.state.data.count} />}
            className="mb-20"
            tooltipText={this.tooltipText(this.state.data.count, "negócios iniciados")}
            delta={<AnimatedValue value={this.state.data.countDelta} />}
            deltaTooltipText={this.deltaTooltipText(this.state.data.countDelta, (value) => { return `${value} novas oportunidades`; })}
            deltaType={deltaCalculator.deltaType(this.state.data.countDelta)}
            url={this.getDetailsUrl()}
          />

          <Summary
            value={<AnimatedValue value={this.state.data.amount} formatter={currencyFormatter.formatCentsToCurrency} />}
            tooltipText={this.tooltipText("Valor total de negócios", "iniciados")}
            delta={<AnimatedValue value={this.state.data.amountDelta} formatter={currencyFormatter.formatCentsToCurrency} />}
            deltaTooltipText={this.deltaTooltipText(this.state.data.amountDelta, currencyFormatter.formatCentsToCurrency)}
            deltaType={deltaCalculator.deltaType(this.state.data.amountDelta)}
            url={this.getDetailsUrl()}
          />
        </CenteredCardContent>
      </CardWithLoader>
    );
  }
});

module.exports = NewDealsWidget;



// WEBPACK FOOTER //
// ./app/screens/Dashboard/components/Widgets/new-deals-widget.jsx